import React, { useState } from 'react';
import { COUNTRY_COMPARISON_RESULTS_MAX_SELECTION, LABEL_FOR_COUNTRIES_SEARCH_FIELD } from '../../../constants';
import { ComponentWithFilterHandlersProps, Taxonomies } from '../../../types';
import Button from '../../layout/button/button.component';
import TaxonomyListBox from '../taxonomy-list-box/taxonomy-list-box.component';
import Title from '../../layout/title/title.component';
import {
    countryComparisonTitleAndFiltersClassName,
    countryComparisonTitleAndFiltersTopClassName,
    countryComparisonTitleAndFiltersBottomClassName,
    countryComparisonTitleAndFiltersTopDescriptionClassName
} from './country-comparison-title-and-filters.style';
import { Cell, Grid } from '../../layout/grid/grid.component';
import Select from '../../layout/form/select.component';
import Icon from '../../layout/icon/icon.component';

interface CountryComparisonTitleAndFiltersProps extends ComponentWithFilterHandlersProps {
    title: string;
    description: string;
    taxonomies: Taxonomies;
}

const CountryComparisonTitleAndFilters: React.FC<CountryComparisonTitleAndFiltersProps> = ({
    title,
    description,
    filters,
    taxonomies,
    onChangeFilters
}) => {
    const [filterCountryIds, changeFilterCountryIds] = useState<number[]>([...filters.countryIds]);
    const [localLevel, changeLocalLevel] = useState<boolean>(filters.localLevel);

    const handleClickConfirmFiltersButton = () => {
        onChangeFilters({
            ...filters,
            countryIds: filterCountryIds,
            localLevel,
        });
    };

    const localLevelOptions = [
        {value: '1', label: 'Parliament'},
        {value: '2', label: 'Local government'},
    ];

    const hasChanges = () => {
        if (localLevel !== filters.localLevel) {
            return true;
        }

        if (filterCountryIds.length !== filters.countryIds.length) {
            return true;
        }

        const sortedCurrentCountryIds = [...filters.countryIds].sort();
        const sortedNewCountryIds = [...filterCountryIds].sort();

        for (let i = 0; i < sortedCurrentCountryIds.length; i++) {
            if (sortedCurrentCountryIds[i] !== sortedNewCountryIds[i]) {
                return true;
            }
        }

        return false;
    };

    return (
        <div className={ countryComparisonTitleAndFiltersClassName }>
            <div className={ countryComparisonTitleAndFiltersTopClassName }>
                <Title>{ title }</Title>
                <div
                    className={ countryComparisonTitleAndFiltersTopDescriptionClassName }
                    dangerouslySetInnerHTML={ {__html: description} }/>
                <Grid>
                    <Cell>
                        <Select
                            value={ localLevel ? '2' : '1' }
                            onChange={ (newValue) => changeLocalLevel(newValue === '2') }
                            options={ localLevelOptions }>
                            <Button format='white'>
                                <span style={ {marginRight: '10px'} }>
                                    { localLevel ? 'Local government' : 'Parliament' }
                                </span>
                                <Icon name='dropdown' mirroring='y' />
                            </Button>
                        </Select>
                    </Cell>
                    <Cell>
                        <Button onClick={ handleClickConfirmFiltersButton } disabled={ !hasChanges() }>
                            Confirm selection
                        </Button>
                    </Cell>
                </Grid>
            </div>
            <div className={ countryComparisonTitleAndFiltersBottomClassName }>
                <TaxonomyListBox
                    title='Country'
                    taxonomyType='countries'
                    taxonomies={ taxonomies.countries }
                    selectedIds={ filterCountryIds }
                    onChange={ changeFilterCountryIds }
                    searchField={ LABEL_FOR_COUNTRIES_SEARCH_FIELD}
                    grouped
                    maxSelections={ COUNTRY_COMPARISON_RESULTS_MAX_SELECTION }/>
            </div>
        </div>
    );
};

export default CountryComparisonTitleAndFilters;
